import React from 'react';
import { useTheme } from '@mui/material/styles';

const getStyles = (theme) => ({
  wrapper: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
    boxShadow: theme.shadows[8],
    maxWidth: 420,
    overflow: 'hidden',
    width: '100%',
  },
  accentBar: {
    backgroundColor: theme.palette.primary.main,
    height: 6,
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '16px 20px 0',
  },
  title: {
    color: theme.palette.text.primary,
    fontSize: '1rem',
    fontWeight: 700,
    margin: 0,
  },
  closeBtn: {
    background: 'none',
    border: 'none',
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    fontSize: '18px',
    lineHeight: 1,
    padding: '4px',
  },
  divider: {
    backgroundColor: theme.palette.divider,
    border: 'none',
    height: 1,
    margin: '12px 20px 0',
  },
  content: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    lineHeight: 1.7,
    padding: '16px 20px',
  },
  footer: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0 20px 16px',
  },
  footerRight: {
    alignItems: 'center',
    display: 'flex',
    gap: 10,
  },
  skipBtn: {
    background: 'none',
    border: 'none',
    color: theme.palette.text.secondary,
    cursor: 'pointer',
    fontSize: '0.8rem',
    fontWeight: 500,
    padding: '6px 8px',
  },
  backBtn: {
    backgroundColor: 'transparent',
    border: `1.5px solid ${theme.palette.primary.light}`,
    borderRadius: 8,
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: '0.85rem',
    fontWeight: 600,
    padding: '8px 20px',
  },
  nextBtn: {
    backgroundColor: theme.palette.primary.main,
    border: 'none',
    borderRadius: 8,
    color: theme.palette.primary.contrastText,
    cursor: 'pointer',
    fontSize: '0.9rem',
    fontWeight: 700,
    padding: '10px 28px',
    width: '100%',
  },
  progress: {
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    fontWeight: 500,
  },
});

const TourTooltip = ({
  continuous,
  index,
  step,
  size,
  backProps,
  closeProps,
  primaryProps,
  skipProps,
  tooltipProps,
  isLastStep,
}) => {
  const theme = useTheme();
  const styles = getStyles(theme);
  const showBack = index > 0;
  const showFullWidthNext = !showBack;

  return (
    <div {...tooltipProps} style={styles.wrapper}>
      <div style={styles.accentBar} />

      {/* Header */}
      <div style={styles.header}>
        {step.title && <h4 style={styles.title}>{step.title}</h4>}
        <button {...closeProps} style={styles.closeBtn} aria-label="Cerrar">
          ✕
        </button>
      </div>

      <hr style={styles.divider} />

      {/* Content */}
      <div style={styles.content}>{step.content}</div>

      {/* Footer */}
      <div style={{ padding: '0 20px 16px' }}>
        {showFullWidthNext ? (
          /* First step: full-width button + skip below */
          <div>
            <button {...primaryProps} style={styles.nextBtn}>
              {continuous ? primaryProps.title : primaryProps.title}
            </button>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 10 }}>
              <button {...skipProps} style={styles.skipBtn}>
                {skipProps.title}
              </button>
              <span style={styles.progress}>
                {index + 1} / {size}
              </span>
            </div>
          </div>
        ) : (
          /* Subsequent steps: skip | progress | back + next */
          <div>
            <div style={{ ...styles.footer, padding: 0 }}>
              <button {...skipProps} style={styles.skipBtn}>
                {skipProps.title}
              </button>
              <div style={styles.footerRight}>
                <button {...backProps} style={styles.backBtn}>
                  {backProps.title}
                </button>
                <button
                  {...primaryProps}
                  style={{
                    ...styles.nextBtn,
                    width: 'auto',
                    padding: '8px 28px',
                  }}
                >
                  {primaryProps.title}
                </button>
              </div>
            </div>
            <div style={{ textAlign: 'center', marginTop: 10 }}>
              <span style={styles.progress}>
                {index + 1} / {size}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TourTooltip;
